import { MedosClient } from "../client/MedosClient";
import { ENDPOINTS } from "../constants/endpoints";
import { AuthService } from "./AuthService";
const WorkspaceV2Service = {
    async fetchWorkspace(patientCountryCode) {
        const client = await MedosClient.ensureInitialized();
        const externalMemberId = MedosClient.getExternalMemberId();
        const params = {};
        if (externalMemberId)
            params.externalId = externalMemberId;
        if (patientCountryCode)
            params.patientCountryCode = patientCountryCode;
        const res = await client.get(ENDPOINTS.workspace.fetch, {
            params: Object.keys(params).length > 0 ? params : undefined,
            baseURL: MedosClient.getApiBaseUrlV2(),
        });
        const workspace = res.data;
        const sessionWorkspace = AuthService.getSessionWorkspace(workspace.workspaceId);
        if (!sessionWorkspace) {
            return workspace;
        }
        return {
            ...workspace,
            appointmentSystemType: workspace.appointmentSystemType ??
                sessionWorkspace.appointmentSystemType,
            features: workspace.features ?? sessionWorkspace.features,
            usageLimits: workspace.usageLimits ?? sessionWorkspace.usageLimits,
            arePackagesConfigured: workspace.arePackagesConfigured ??
                sessionWorkspace.arePackagesConfigured,
            videoProvider: workspace.videoProvider ?? sessionWorkspace.videoProvider,
            isAppointmentInvoiceConfig: workspace.isAppointmentInvoiceConfig ??
                sessionWorkspace.isAppointmentInvoiceConfig,
        };
    },
};
export { WorkspaceV2Service };
